module.exports = __webpack_public_path__ + "static/media/Cardoso_Logo.9faaa6b9.png";